import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import explorerEn from "./locales/en/explorer.json";
import explorerPt from "./locales/pt/explorer.json";
import explorerEs from "./locales/es/explorer.json";
import { DEFAULT_LANG } from "shared/constants/StorageConsts";

const getBrowserLanguage = () => {
  try {
    const supportedLanguages = ["es", "en", "pt"];
    const navigatorLanguage = navigator.language;
    const lng = navigatorLanguage?.substring(0, 2);
    if (supportedLanguages.find((x) => lng === x)) {
      return lng;
    } else {
      return null;
    }
  } catch {
    return null;
  }
};

const browserLang = getBrowserLanguage();

const resources = {
  en: {
    explorer: explorerEn,
  },
  pt: {
    explorer: explorerPt,
  },
  es: {
    explorer: explorerEs,
  },
};
i18n.use(initReactI18next).init({
  ns: ["explorer"],
  defaultNS: "explorer",
  lng: browserLang ?? DEFAULT_LANG,
  returnObjects: true,
  resources,
  debug: false,
});

export default i18n;
